import Name from "../Name/name.jsx";
import Banner from "../Banner/banner.jsx";
import Prestation from "../Prestation/prestation.jsx";
import Contact from "../Contact/contact.jsx";
import Footer from "../Footer/footer.jsx";

export default function IndexPage() {
  return (
    <div className="index-page">
      <Name />
      <Banner />
      <Prestation />
      <Contact />
      <div className="gap"></div>
      <Footer />
    </div>
  );
}
